import React from "react";
import { Link } from "react-router-dom";
import { Quote, Globe2, Award, ArrowRight } from "lucide-react";
import PageHeader from "../components/PageHeader";
import { welcomeMessage, conference, stats } from "../mock";
import { useReveal } from "../hooks/useReveal";

const About = () => {
  useReveal();
  return (
    <div>
      <PageHeader title="About DRS 2026" crumb="About" subtitle={`${conference.fullName} \u2014 ${conference.tagline}.`} />
      <section className="section-pad bg-white">
        <div className="max-w-7xl mx-auto px-5 lg:px-8 grid lg:grid-cols-3 gap-12">
          <div className="lg:col-span-2 reveal">
            <span className="text-brand font-semibold tracking-[0.2em] uppercase text-sm">Welcome Message</span>
            <h2 className="mt-3 font-display font-extrabold text-3xl md:text-4xl text-navy-900">{welcomeMessage.heading}</h2>
            <div className="mt-4 w-20 h-1 bg-brand rounded-full" />
            <Quote className="w-10 h-10 text-orange-200 mt-6" />
            <p className="mt-2 text-lg text-slate-700 leading-relaxed font-medium">{welcomeMessage.lead}</p>
            <div className="mt-4 space-y-4 text-slate-600 leading-relaxed">
              {welcomeMessage.paragraphs.map((p, i) => <p key={i}>{p}</p>)}
            </div>
            <p className="mt-6 font-display font-semibold text-navy-900">— {welcomeMessage.signature}</p>
            <Link to="/registration" className="mt-8 btn-shine inline-flex items-center bg-brand hover:bg-brand-600 text-white font-semibold rounded-full px-7 h-12 transition-colors">Register for DRS 2026 <ArrowRight className="w-4 h-4 ml-2" /></Link>
          </div>

          <aside className="reveal space-y-5">
            <div className="rounded-2xl bg-navy-800 text-white p-6">
              <Globe2 className="w-8 h-8 text-brand" />
              <h3 className="mt-3 font-display font-bold text-lg">IDF Collaboration</h3>
              <p className="mt-2 text-sm text-slate-300 leading-relaxed">{conference.idfNote}</p>
            </div>
            <div className="rounded-2xl border border-slate-100 shadow-sm p-6">
              <Award className="w-8 h-8 text-brand" />
              <h3 className="mt-3 font-display font-bold text-lg text-navy-900">At a Glance</h3>
              <ul className="mt-3 space-y-3">
                {stats.map((s) => (
                  <li key={s.label} className="flex items-center justify-between border-b border-slate-100 pb-2">
                    <span className="text-sm text-slate-500">{s.label}</span>
                    <span className="font-display font-bold text-navy-900">{s.value}{s.suffix}</span>
                  </li>
                ))}
              </ul>
            </div>
            <div className="rounded-2xl bg-orange-50 border border-orange-100 p-6">
              <h3 className="font-display font-bold text-navy-900">Organised by</h3>
              <p className="mt-1 text-brand font-semibold">{conference.organisedBy}</p>
              <p className="mt-3 text-sm text-slate-600">Endorsed by the {conference.endorsedBy}.</p>
            </div>
          </aside>
        </div>
      </section>
    </div>
  );
};

export default About;
